module.exports = __webpack_public_path__ + "img/delete.ce8f0d65.svg";